import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-premium-service-toggle',
  standalone: true,
  templateUrl: './premium-service-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PremiumServiceToggleComponent {
  @Input() added = false;
  @Output() action = new EventEmitter<void>();

  handleAction(): void {
    this.action.emit();
  }
}
